/**
 * This is a well known constant which will be used as a placeholder for the client id when built-in Google IDP is used
 */
export const PLACEHOLDER_BUILT_IN_GOOGLE_IDP_CLIENT_ID =
  'BUILT_IN_GOOGLE_IDP_CLIENT_ID';

/**
 * This is a well known constant which will be used as a placeholder for the client secret when built-in Google IDP is used
 */
export const PLACEHOLDER_BUILT_IN_GOOGLE_IDP_CLIENT_SECRET =
  'BUILT_IN_GOOGLE_IDP_CLIENT_SECRET';

/**
 * This is a well known constant which will be used as a placeholder for the client id when built-in Azure AD IDP is used
 */
export const PLACEHOLDER_BUILT_IN_AZURE_AD_IDP_CLIENT_ID =
  'BUILT_IN_AZURE_AD_IDP_CLIENT_ID';

/**
 * This is a well known constant which will be used as a placeholder for the client secret when built-in Azure AD IDP is used
 */
export const PLACEHOLDER_BUILT_IN_AZURE_AD_IDP_CLIENT_SECRET =
  'BUILT_IN_AZURE_AD_IDP_CLIENT_SECRET';
